import { TagType } from '@myre/common-tag';

import { QuestionHidden, type IQuestionHidden } from './question-hidden';

export interface IQuestionCollapseTag extends IQuestionHidden<string> {
  tagType?: TagType;
}

export class QuestionCollapseTag
  extends QuestionHidden<string>
  implements IQuestionCollapseTag
{
  public tagType: TagType;

  constructor(options: IQuestionCollapseTag) {
    super(options);

    this.tagType = options?.tagType ?? TagType.Tertiary;
    this.elementType = 'collapseTag';
    this.size = 0;
  }

  public override update(emitEvent: boolean = false): void {
    this._formControl.updateValueAndValidity({ emitEvent, onlySelf: true });
  }
}
